// Import Packages
import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import Draggable from "react-draggable";

// Import Material UI
import Dialog from "@material-ui/core/Dialog";
import Button from "@material-ui/core/Button";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Paper from "@material-ui/core/Paper";
import Close from "@material-ui/icons/Close";

// Import Icons
import donloadLogIcon from "../../assets/icons/configurationIcons/advange-log-download.svg";
import InfoIcon from "../../assets/icons/configurationIcons/display-message-info-icon.svg";

function PaperComponent(props) {
  return (
    <Draggable
      handle="#display-message-header-container"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper
        style={{
          minHeight: 200, wordBreak: "break-word", width: 520, height: 470, borderRadius: "5px",
          boxShadow: "0px 0px 8px -3px #00000040", background: "#FFFFFF", padding: "20px 25px 35px 25px", gap: "5px"
        }}
        {...props}
      />
    </Draggable>
  );
}

function DisplayMessage(props) {
  const [open, setOpen] = useState(true);

  const { t } = useTranslation();
  useEffect(() => {
    if (props.message?.length > 0) {
      setOpen(true);
    }
  }, [props.random]);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };
  function handleChange(event) {
    if (event.code === "Escape") {
      setOpen(false);
    }
  }

  const handleDownload = () => {
    const fileName = new Date().getTime().toString();
    // Blob oluşturma
    const blob = new Blob([props.message], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);

    // Geçici bir `a` etiketi oluşturup indirme işlemi başlatma
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName + '.txt';
    document.body.appendChild(link);
    link.click();

    // Temizlik işlemi
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  return (
    <div onKeyDown={(e) => handleChange(e)}>
      <Dialog
        open={open}
        onClose={handleClose}
        PaperComponent={PaperComponent}
        aria-labelledby="display-message-header-container"
      >
        <DialogTitle style={{ cursor: "move" }} id="display-message-header-container">
          <div id="display-message-about-container">
            <p id="display-message-about-title">
              <strong>{props.title}</strong>
              <span> - {t('CONTENT.LIBRARY.DISPLAY-MESSAGE.NAME')}</span>
            </p>
            <p id="display-message-about-description">
              {t('CONTENT.LIBRARY.DISPLAY-MESSAGE.DESCRIPTION')}
            </p>
          </div>
          <div id="display-message-function-container">
            <Close className="logs-close-icon" onClick={handleClose} style={{ fontSize: "1.1rem", color: "#4F6E90" }} />
            {props.message?.length <= 1000 ? <Button id="display-message-download-txt-button" onClick={handleDownload}> <img src={donloadLogIcon} /> {t('CONTENT.LIBRARY.DISPLAY-MESSAGE.DOWNLOAD-TXT')}</Button> : ""}
          </div>
        </DialogTitle>
        {props.message?.length > 1000 ?
          <div id="display-message-info-container">
            <img src={InfoIcon} />
            <span>{t('CONTENT.LIBRARY.DISPLAY-MESSAGE.1000-LIMIT')}</span>
            <Button className="display-message-limit-download" onClick={handleDownload}>{t('CONTENT.LIBRARY.DISPLAY-MESSAGE.DOWNLOAD-TXT')}</Button>
          </div>
          : ""}
        <DialogContent id="display-message-content-container">
          <p id="display-message-content">{props.message && props.message?.length > 1000 ? props.message.slice(0, 1000) : props.message}</p>
        </DialogContent>
      </Dialog>
    </div>
  );
}
export default DisplayMessage;

